// D-0157 — % Tributo fornecedor de cada etapa (Pré-evento, Negociado, Fechamento).
// Cada etapa grava o seu % em impostoPorcentagemItem<Etapa>; mudar numa não muda nas outras. Levar
// o % de uma etapa para outra só pelo Copiar dos 3 pontinhos. Na linha 1945 (Imposto NF Access) as
// mesmas chaves guardam o % da NF Access de cada etapa.
// O campo antigo impostoPorcentagemItem é só reserva: vale quando a linha não tem a chave da etapa
// (linha antiga ainda não recarregada). Mesma regra da API (App\Classes\OrcamentoTributoEtapa).

export const CAMPO_TRIBUTO_LEGADO = 'impostoPorcentagemItem';
export const ETAPAS_TRIBUTO = ['PreEvento', 'Negociado', 'Fechamento'];

const normalizarEtapa = (etapa = '') => {
    const chave = String(etapa).replace(/[_\-\s]/g, '').toLowerCase();
    if (chave === 'preevento' || chave === 'pre') return 'PreEvento';
    if (chave.startsWith('negociado')) return 'Negociado';
    if (chave === 'fechamento') return 'Fechamento';
    return etapa;
};

export const campoTributo = (etapa) => `${CAMPO_TRIBUTO_LEGADO}${normalizarEtapa(etapa)}`;

// Valor cru da etapa, como a tela mostra no campo (sem a chave da etapa, o antigo).
export function tributoEtapa(subitem = {}, etapa = 'PreEvento') {
    const campo = campoTributo(etapa);
    if (subitem && Object.prototype.hasOwnProperty.call(subitem, campo)) return subitem[campo];
    return subitem?.[CAMPO_TRIBUTO_LEGADO];
}

// As três chaves com o mesmo valor (linha nova, linha calculada).
export const tributosPadrao = (valor = '0') => ETAPAS_TRIBUTO.reduce((acc, etapa) => {
    acc[campoTributo(etapa)] = valor;
    return acc;
}, {});

// Linha antiga sem as chaves por etapa: copia o antigo para as três, uma vez, ao carregar.
export function completarTributosEtapa(subitem = {}) {
    if (!subitem || typeof subitem !== 'object') return subitem;
    ETAPAS_TRIBUTO.forEach((etapa) => {
        const campo = campoTributo(etapa);
        if (!Object.prototype.hasOwnProperty.call(subitem, campo)) subitem[campo] = subitem[CAMPO_TRIBUTO_LEGADO] ?? null;
    });
    return subitem;
}
